module.exports = __webpack_public_path__ + "img/page28.902a2fac.gif";